import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
  type ISourceEntity,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard } from '@principle-theorem/shared';
import { flow, isBoolean, isString } from 'lodash';
import { STAFFER_RESOURCE_TYPE } from '../../../destination/entities/staff';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';
import { convertValueFn } from '../../../source/source-helpers';
import { STAFF_DESTINATION_ENTITY } from '../../destination/entities/staff';

export const STAFFER_SOURCE_ENTITY: ISourceEntity = SourceEntity.init({
  metadata: {
    label: 'Staffer List',
    description: '',
    idPrefix: STAFFER_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface IExactStaffer {
  id: string;
  title: string | null;
  first_name: string | null;
  surname: string | null;
  middle_name: string | null;
  name: string | null;
  email: string;
  is_inactive: boolean;
}

function isExactStafferListItem(
  item: unknown,
  logError: boolean
): item is IExactStaffer {
  return TypeGuard.interface<IExactStaffer>(
    {
      id: isString,
      title: TypeGuard.nilOr(isString),
      first_name: TypeGuard.nilOr(isString),
      surname: TypeGuard.nilOr(isString),
      middle_name: TypeGuard.nilOr(isString),
      name: TypeGuard.nilOr(isString),
      email: isString,
      is_inactive: isBoolean,
    },
    logError
  )(item);
}

const STAFF_SOURCE_QUERY = `
SELECT
  NULLIF(id::TEXT, '') as id,
  NULLIF(title, '') as title,
  NULLIF(firstname, '') AS first_name,
  NULLIF(surname, '') AS surname,
  NULLIF(middlename, '') AS middle_name,
  NULLIF(name, '') AS name,
  email,
  isinactive AS is_inactive
FROM
  convprovider
WHERE
  NULLIF(id::TEXT, '') IS NOT NUll
`;

export type ExactStaffer = ISourceEntityTypes<IExactStaffer>;

export class StafferSourceEntity extends BaseSourceEntity<ExactStaffer> {
  sourceEntity = STAFFER_SOURCE_ENTITY;
  entityResourceType = STAFFER_RESOURCE_TYPE;
  sourceQuery = STAFF_SOURCE_QUERY;
  verifySourceFn = isExactStafferListItem;

  migrationDestinations = [STAFF_DESTINATION_ENTITY.metadata.key];

  override transformDataFn = flow([
    convertValueFn((value) => String(value).replace(/\//g, '-'), 'id'),
  ]);

  translate(_staffer: IExactStaffer): Record<symbol, unknown> {
    return {};
  }

  getSourceRecordId(data: IExactStaffer): string {
    return data.id;
  }

  getSourceLabel(data: IExactStaffer): string {
    const name = data.name ?? `${data.first_name} ${data.surname}`;
    return `${data.id} ${name}`;
  }
}
